export default __webpack_public_path__ + "static/media/desk09.44aa3a8c.jpg";